import { useState } from "react";
import { AppBar, Box, Container, Toolbar } from "@mui/material";
import MobileMenu from "./MobileMenu";
import Logo from "./Logo";
import Menu from "./Menu";
import type { SubMenuItem } from "./Menu";
import { useTranslation } from "react-i18next";
import LanguageSwitch from "../LanguageSwitch";
import { useHistory, useLocation } from "react-router-dom";

export type MenuItems = {
  id: number;
  title: string;
  url: string;
  btn?: boolean;
  subMenu?: {
    id: number;
    title: string;
    url: string;
    imgSrc: string;
  }[];
}[];

type HeaderProps = {
  onAssistantClick?: () => void;
};

const Header: React.FC<HeaderProps> = ({ onAssistantClick }) => {
  const { t } = useTranslation("", { keyPrefix: "Header" });
  const menuItems: MenuItems = t("menu", { returnObjects: true });
  const submenu: SubMenuItem[] = t("submenu", { returnObjects: true });
  const history = useHistory();
  const location = useLocation();

  const [mobileOpen, setMobileOpen] = useState(false);

  const scrollToAssistant = () => {
    if (location.pathname === "/products/newmove") {
      const el = document.getElementById("assistant-section");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      history.push("/products/newmove");
      setTimeout(() => {
        const el = document.getElementById("assistant-section");
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <AppBar component="nav" elevation={25} sx={{ backgroundColor: "#EDEDED" }}>
      <Container>
        <Toolbar disableGutters>
          <MobileMenu
            menuItems={menuItems}
            submenu={submenu}
            onDrawerToggle={handleDrawerToggle}
            mobileOpen={mobileOpen}
            onAssistantClick={scrollToAssistant}
          />

          <Logo />

          <Menu menuItems={menuItems} submenu={submenu} onAssistantClick={scrollToAssistant} />

          <Box sx={{ width: "48px", textAlign: "center", fontSize: "1.2rem" }}>
            <LanguageSwitch sx={{ display: { md: "none" } }} shortcode={true} underline="none" />
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
